import get from "lodash/get";

import {LHRAudit, LHRCategory, PSReportCategories} from "@/pages/pagespeed/types.ts";

export const getCategoryScore = (categories: PSReportCategories, category: string): number => {
  const cat: LHRCategory = get(categories, category);
  return Math.round(cat.score * 100);
};

export const getAuditDisplay = (audits: Record<string, LHRAudit>, auditName: string): string => {
  const audit = audits[auditName];
  if (audit?.displayValue) {
    return audit.displayValue;
  }
  return "n/a";
};
